import {
  ENV_PRODUCTION,
  HOLDERS_UNLOCK_MULTIFARM,
  QUEST_TAP_POOL_ID
} from '../constants/app'

const isEnvProduction = () => {
  return process.env.REACT_APP_ENV === ENV_PRODUCTION
}

const isSaleEnded = (endTime) => {
  return new Date().getTime() >= endTime
}

const openBlankRedirectPage = (url) => {
  window.open(url, '_blank')
}

const isCustomVestingFlow = (id) => {
  return [QUEST_TAP_POOL_ID, HOLDERS_UNLOCK_MULTIFARM].includes(id)
}

export {
  isEnvProduction,
  isSaleEnded,
  openBlankRedirectPage,
  isCustomVestingFlow
}
